package fr.manyverse.app.presentation.theme

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
actual fun isSystemInDarkTheme(): Boolean {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
}